
export default {
  productData: {
    serialNumber: 'DA-MME-004',
    name: 'Massivholzdecke mit Estrich l Aufbau 4',
    construction: {
      composition: [
        {
          type: 'screed',
          title: { de: 'Trockenestrichplatten mit integrierter Fußbodenheizung' },
          output: '20',
          value: 'd-20'
        },
        {
          type: 'suspendedCeilingA',
          title: { de: 'Gipsfaserplatten' },
          output: '10',
          value: 'gp-10'
        },
        {
          type: 'insulation',
          title: { de: 'Holzfaserdämmplatte WF<br>(<i>s‘</i> ≤ 20 MN/m<sup>3</sup>; Anwendungsgebiet DES-sh)' },
          output: '≥ 20',
          value: 'w-20'
        },
        {
          type: 'fill',
          title: { de: 'Mit StoPrefa Coll SB gebundene Schüttung (<i>m‘</i> ≥ 190 kg/m<sup>2</sup>), Rieselschutz' },
          output: '≥ 120',
          value: 'scsb-120'
        },
        {
          type: 'supportingStructure',
          title: { de: 'Massivholzdecke (Steico GLVL)' },
          output: 120,
          value: 'mh-120'
        }
      ],
      sum: {
        output: '290', value: 290
      }
    },
    technicalValues: {
      impactSoundLevel: { // L,nw
        output: '45 (-1; 4)',
        value: 45
      },
      soundReductionIndex: { // Rw
        output: '68 (-4; -11)',
        value: 68
      },
      heatTransferCoefficient: { // U-Wert
        output: '0,49',
        value: 0.49
      },
      fireResistance: {
        output: 'F 30-B',
        value: 'F-30-B'
      },
      massPerUnitArea: {
        output: '316 [kg/m²]'
      }
    }
  },
  image: 'da-mme-004.png',
  pdf: 'Massivholzdecke-mit-Estrich-Aufbau-4-DA-MME-004-Rev01.pdf'
}
